import React from 'react';
import { Star } from 'lucide-react';

export const StarRating = ({ rating, maxRating = 5, size = 'md', showValue = true }) => {
  const sizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  return (
    <div className="flex items-center gap-1">
      <div className="flex gap-0.5">
        {[...Array(maxRating)].map((_, index) => (
          <Star
            key={index}
            className={`${sizes[size]} ${
              index < rating
                ? 'text-yellow-500 fill-yellow-500'
                : 'text-gray-300'
            }`}
          />
        ))}
      </div>
      {showValue && (
        <span className="text-sm font-medium ml-1">{rating.toFixed(1)}</span>
      )}
    </div>
  );
};

export const InteractiveStarRating = ({ value, onChange, maxRating = 5 }) => {
  const [hover, setHover] = React.useState(0);

  return (
    <div className="flex gap-1">
      {[...Array(maxRating)].map((_, index) => {
        const starValue = index + 1;
        return (
          <button
            key={index}
            type="button"
            onClick={() => onChange(starValue)}
            onMouseEnter={() => setHover(starValue)}
            onMouseLeave={() => setHover(0)}
            className="transition-transform hover:scale-110"
            data-testid={`star-${starValue}`}
          >
            <Star
              className={`w-8 h-8 transition-colors ${
                starValue <= (hover || value)
                  ? 'text-yellow-500 fill-yellow-500'
                  : 'text-gray-300'
              }`}
            />
          </button>
        );
      })}
    </div>
  );
};
